module.exports = __webpack_public_path__ + "static/media/box_steps_mobile.b169c8fb.jpg";